export default class LocalSerializedObjectIdentifier {
  public localSerializedFileIndex!: int;
  public localIdentifierInFile!: bigint;
}
